'use client';
import React, { useState } from 'react';
import { Button, Chip, Div, Media, Modal } from '@pezeshk-book/ui-kit';
import { useDispatch } from 'react-redux';
import { AlertActions } from '@store/alert/alert-action';
import { useParams } from 'next/navigation';
import getDictionary from '@dictionaries-client';
import { LocaleTypes } from '@dictionaries-types';

const ServiceTutorial = ({ source, disable = false, onProgress = false }: {source: string, disable?: boolean, onProgress?: boolean}) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { lang } = useParams<{lang: LocaleTypes}>();
  const { services } = getDictionary(lang);

  const handleClick = () => {
    if (!onProgress) {
      setOpen(true);
    } else {
      dispatch(AlertActions.showAlert({ text: services.messages.video_tutorial, severity: 'warning' }));
    }
  };
  return (
    <>
      <Media greaterThan={'sm'} className={'w-full'}>
        <Button color={'control'} disabled={disable} onClick={handleClick} variant={'outlined'} className={'w-full'}>
          {services.buttons.video_tutorial}
        </Button>
      </Media>
      <Media lessThan={'md'} className={'w-1/4'}>
        <Button color={'control'} disabled={disable} onClick={handleClick} variant={'outlined'} className={'w-full'}>
          {services.buttons.tutorial}
        </Button>
      </Media>
      {open ? (
        <Modal open={open} onClose={() => setOpen(false)}>
          <Div className={'bg-white rounded-2xl p-5 w-11/12 md:w-3/4 flex-col'}>
            <Chip color={'danger'} onDelete={() => setOpen(false)} value={services.chips.close} onClick={() => setOpen(false)} className={'relative mb-2'} variant={'outlined'}/>
            <video width={'100%'} height={'100%'} autoPlay={true} controls={true}>
              <source src={source}/>
            </video>
          </Div>
        </Modal>
      ) : null}
    </>
  );
};

export default ServiceTutorial;
